import { render, staticRenderFns } from "./PackagingTable.vue?vue&type=template&id=20127106&scoped=true"
import script from "./PackagingTable.vue?vue&type=script&lang=js"
export * from "./PackagingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20127106",
  null
  
)

export default component.exports